import { getOrdersOrderIdCalculatePrice } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const useCalculator = (orderId: number) => {
	return useQuery({
		queryKey: ["ORDER_CALCULATE_PRICE", orderId],
		queryFn: processResponse(() => getOrdersOrderIdCalculatePrice(orderId)),
		enabled: false,
	});
};
